/**
 * Display at: @features/general/icons
 */

import { library as fontawesome } from "@fortawesome/fontawesome-svg-core";
import icons from "@/assets/icons";

fontawesome.add(icons);
